
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericDefaultOutlined as ObiVesselGenericDefaultOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-default-outlined.js';
 
 
 

 
 export const ObiVesselGenericDefaultOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-default-outlined',
   elementClass: ObiVesselGenericDefaultOutlinedElement,
   events: {
     
   }
  });
 
 